import { MediaItem } from '../../types';
import { fetchMediaJsonFromS3 } from './mediaItemService';

interface ReloadHandlers {
  setAllMediaItemsFromDB: (items: MediaItem[]) => void;
  setInitialMediaItems: (items: MediaItem[]) => void;
  showNotification: (notification: {
    type: 'success' | 'error' | 'info' | 'warning';
    title: string;
    message: string;
  }) => void;
}

/**
 * Reload media items from database (S3)
 * Used after preview generation to fetch newly created preview segments
 */
export const reloadMediaItemsFromDB = async (
  projectId: string,
  handlers: ReloadHandlers
): Promise<void> => {
  if (!projectId) return;
  
  console.log('🔄 [RELOAD] Fetching fresh media items from S3');
  
  try {
    const response = await fetchMediaJsonFromS3(projectId);
    const data = response as MediaItem[];
    
    if (data?.length) {
      console.log('📦 [RELOAD] Total items from DB:', data.length);
      
      // Count preview segments
      const previewSegments = data.filter(item => 
        item.effect?.includes('preview-segment')
      );
      console.log('📦 [RELOAD] Preview segments found:', previewSegments.length);
      
      // Update allMediaItemsFromDB with fresh data
      handlers.setAllMediaItemsFromDB(data);
      
      // Filter out archived AND preview segments for active timeline
      const activeData = data.filter(item => 
        item?.effect !== 'archived' && 
        !item?.effect?.startsWith('preview-segment')
      );
      
      // Update initial state
      handlers.setInitialMediaItems(activeData);
      
      console.log('✅ [RELOAD] Media items reloaded successfully');
      
      handlers.showNotification({
        type: 'success',
        title: 'Preview Segments Loaded',
        message: `${previewSegments.length} preview segments are now available`
      });
    }
  } catch (error) {
    console.error('❌ [RELOAD] Error fetching media:', error);
    handlers.showNotification({
      type: 'error',
      message: 'Failed to reload media items',
      title: 'Error'
    });
  }
};
